import React from "react";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "../../../../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
// import Attachement from "./Attachement";
import Dasboard from "../../../../../../Components/Icons/Dasboard";
import * as yup from "yup";
import { Modal, notification } from "antd";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import Breadcrumb from "../../../../../../Components/Utils/Breadcrumb";
import { NuInput, NuLabel, NuSelect, NuTextArea } from "../../../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import axiosInstance from "../../../../../../Services/axiosCommon";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";



function EditManpowerPro({open, getData, onCancel, data,id,projectId,Category,itemsCategory,Type,refManPowerType=()=>{} }) {
  
  // const {value:Category ,getData:  ManPowerCategory} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerCategory')
  // const {value:Type ,getData:  ManPowerType} = useFetchMataData(`/dropdown/dropdown-details/`,'ManPowerType')
  // console.log('====================================');
  // console.log(Type,"ffffffffffffffffff");
  // console.log('====================================');
    const [api, contextHolder] = notification.useNotification();
  const [isLoading,setIsLoading] = useState(false);
  const [createNew, setCreateNew] = useState({
    projectId:"",
    title_id:"",
    designation:"",
    category:"",
    type:"",
    quantity:"",
    noOfDays:"",
    hours:"",
    comments:""
  });
  useEffect(() => {
    data&&setCreateNew({
    designation: data?.designation || "",
    category: data?.category || "",
    type: data?.type || "",
    quantity: data?.quantity || "",
    noOfDays: data?.noOfDays || "",
    hours: data?.hours || "",
    comments: data?.comments    || "",
   
    })
  },[data])
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: createNew,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema:yup.object({
          designation:yup.string().required("Desigination Name is Requried")
        }),
        onSubmit: (value,{resetForm}) => {
          axiosInstance.put(`/man_power_cost/${data?.id}`, value)
          .then((res) => {
              console.log("res",res.data.status);
              if (res.data.status) {
                getData(id);
                resetForm();
                api.success({
                  message: `Manpower Item Update successfully`,
                  description: res?.data?.msg || "Added In The Activity",
                  placement: "bottomRight",
                });
                onCancel();
              } else {
                api.error({
                  message: `Manpower Item Upadate failed`,
                  description: res?.data?.msg || "Network error",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              api.error({
                message: `failed`,
                description: err?.data?.msg || "Sever error (or) Network error",
                placement: "bottomRight",
              });
            });
        },
      });
      useEffect(() => {
        const totalPrice = formik?.values?.actual_quantity * formik?.values?.actual_Price
        formik.setFieldValue("amount", totalPrice);
      }, [formik?.values?.actual_quantity,formik?.values?.actual_Price]);
      // const { category: itemsCategory, subCategory: itemsSubCategory } =
      // UseCatSubCatDropDown(
      //   "/category/ItemCategory",
      //   "ItemCategory",
      //   formik?.values?.category
      // );
      return (
        <>
        {contextHolder}
        <Modal
          open={open}
          title={"Edit Manpower "}
          width={"50%"}
          className="my-modal"
          centered
          footer={[]}
          onCancel={onCancel}
        >
        <form onSubmit={formik.handleSubmit} >
          <div className=" w-full flex flex-wrap">
          <NuInput
                type="text"
                label="Designation"
                placeholder="Designation"
                formik={formik}
                name="designation"
               width="w-full "
                isRequired={true}
            />
          <FormikSelectTwo
              type="text"
              label="Category"
              placeholder="Category"
              Options={itemsCategory}
              formik={formik}
              name="category"
              width="w-full md:w-1/2"
              // isRequired={true}
            />
             <FormikSelectTwo
              label="Type"
              Options={Type}
              formik={formik}
              placeholder="Choose"
              name="type"
              width="w-full md:w-1/2"
              // getFun={refManPowerType}


          />
              
             <NuInput
                type="number"
                label=" Quantity"
                placeholder=" Quantity"
                formik={formik}
                name="quantity"
                width="w-full md:w-1/2"
              />
              <NuInput
                type="number"
                label="No of Days"
                placeholder="No of Days"
                formik={formik}
                name="noOfDays"
                width="w-full md:w-1/2"
              />
             <NuInput
                type="number"
                label="Hours"
                placeholder="Hours"
                formik={formik}
                name="hours"
                width="w-full md:w-1/2"
              />
             <NuTextArea
                  label="Comments"
                  placeholder="Comments"
                  formik={formik}
                  name="comments"
                  width="w-full md:w-1/2"
                  // new_width="w-full"
                />
                <div className="w-full flex justify-end item-end float-right mx-auto md:mx-0 gap-2 mt-2 md:mr-4">
                  <CancelButton handleClick={onCancel} />
                  <SubmitButton isLoading={isLoading} />
                </div>
          </div>
          </form>
        </Modal>
        </>
      )
    }

export default EditManpowerPro
